<script>
    import Loading from './Loading.svelte'
    import { user } from "../store"

    import axios from "axios";

    
    // ANCHOR sveltestrap
    import {
        Button,
        Card,
        CardBody,
        Container,
        Col,
        Icon,
        Image,
        Row,
        Tooltip
    } from "sveltestrap"

    import { Button as MButton } from 'svelte-materialify';

    import { getContext } from "svelte"
    import { _ } from 'svelte-i18n';

	import ProfilNameDescAge from "./ProfilNameDescAge.svelte";
	import ProfilUpdateNameDescAge from "./Forms/ProfilUpdateNameDescAge.svelte";
    import ProfilInterest from "./ProfilInterest.svelte";
	import ProfilUpdateInterest from "./Forms/ProfilUpdateInterest.svelte";
    import ProfilAbout from './ProfilAbout.svelte';
	import ProfilUpdateAbout from "./Forms/ProfilUpdateAbout.svelte";
    import ProfilPhotoModal from "./ProfilPhotoModal.svelte";

    let apiUrl = getContext("apiUrl");

    export let id, name;

    let fetchProfilUrl = apiUrl + "profile.php";

    if(id)
        fetchProfilUrl = fetchProfilUrl+"?id="+id;
    if(name && id)
        fetchProfilUrl = fetchProfilUrl+"&name="+name;

    // ANCHOR fetchProfil Fonction
    async function fetchProfil() {
        return await axios.get(fetchProfilUrl).then(function (response) {
            if(response.data.redirection){
                document.location.href="/404/"
                return;
            }

            return response.data
        });
    }

    import { useQuery } from '@sveltestack/svelte-query';
 
    // Queries
    const profilData = useQuery('profilData', fetchProfil);

    let update1 = false;
    let updateInterest = false;
    let updateAbout = false;

    const showHideUpdate1 = () => (update1 = !update1);
    const showHideUpdateInterest = () => (updateInterest = !updateInterest);
    const showHideUpdateAbout = () => (updateAbout = !updateAbout);

    let openModalPhoto = false;
    const toggleModalPhoto = () => (openModalPhoto = !openModalPhoto);
</script>



<svelte:head>
    <style>
        .colored-toast.swal2-icon-success {
            background-color: #a5dc86 !important;
        }

        .colored-toast.swal2-icon-error {
            background-color: #f27474 !important;
        }
        .colored-toast .swal2-title {
            color: white;
        }

        .colored-toast .swal2-close {
            color: white;
        }

        .colored-toast .swal2-html-container {
            color: white;
        }
        .colored-toast .swal2-icon {
            color: white;
        }
    </style>
</svelte:head>

<style>
    .btn-transparent {
        opacity: 100%;
    }
</style>

{#if $profilData.isLoading}
    <Loading />
{:else}
    <Container fluid>
        <Row>
            <Col lg="4"  md="3" sm="12" xs="12"></Col>
            <Col lg="4" md="6" sm="12" xs="12">
                <Card color="light">
                    <!--- ANCHOR Profil image --->
                    {#if $profilData.data.id == $user.id}
                        <span id="updatePhoto" class="btn btn-transparent position-absolute top-0 end-0" on:click={toggleModalPhoto}>
                            <Icon name="camera-fill" />
                        </span>
                        <Tooltip target="updatePhoto" placement="right">{$_("components.ProfilComponents.update")}</Tooltip>
                    {:else}
                        <span id="updatePhoto" class="btn btn-transparent position-absolute top-0 end-0" on:click={toggleModalPhoto}>
                            <Icon name="three-dots-vertical" />
                        </span>
                        <Tooltip target="updatePhoto" placement="right">{$_("components.ProfilComponents.options")}</Tooltip>
                    {/if}
                    <!-- TODO Make the real user image -->
                    {#if $profilData.data.photos[0]}
                        {#key $profilData.data.photos}
                            <img src={$profilData.data.photos[0].data} class="card-img" alt={$profilData.data.name}>
                        {/key}
                    {:else}
                        <img src="/img/Portrait_Placeholder.png" class="card-img" alt={$profilData.data.name}>
                    {/if}                    <!--- ANCHOR like profil --->
                    <!-- TODO Add component for this -->
                    {#if $profilData.data.id != $user.id}
                        <div class="text-center">
                            <MButton id="next" class="grey lighten-3 white-text m-2" fab>
                                <Icon name="x-lg" />
                            </MButton>
                            <Tooltip target="next" placement="top">{$_("components.ProfilComponents.next")}</Tooltip>

                            <MButton id="ox" size="x-small" class="yellow accent-4 white-text m-2" fab>
                                <Icon name="star-fill" />
                            </MButton>
                            <Tooltip target="ox" placement="top">{$_("components.ProfilComponents.ox")}</Tooltip>

                            <MButton id="love" class="red accent-3 white-text m-2" fab>
                                <Icon name="heart-fill" />
                            </MButton>
                            <Tooltip target="love" placement="top">{$_("components.ProfilComponents.love")}</Tooltip>
                        </div>
                    {/if}
                </Card>
                <Card color="light" class="mt-2">
                    <!-- ANCHOR Name, description and age -->
                    <CardBody>
                        {#if $profilData.data.id == $user.id}
                            <button id="update1" type="button" class="btn btn-outline-secondary position-absolute top-0 end-0" on:click={showHideUpdate1}>
                                {#if !update1}
                                    <Icon name="pen-fill" />
                                {:else}
                                    <Icon name="x-circle-fill" />
                                {/if}
                            </button>
                            <Tooltip target="update1" placement="right">{$_("components.ProfilComponents.update")}</Tooltip>
                        {/if}
                        <!-- ANCHOR Profile name, age, description -->
                        {#if !update1}
                            <ProfilNameDescAge />
                        {:else}
                            {#if $profilData.data.id == $user.id}
                                <!-- ANCHOR update1 profil -->
                                <ProfilUpdateNameDescAge />
                            {/if}
                        {/if}
                    </CardBody>
                </Card>
                {#if $profilData.data.photos[1]}
                    {#key $profilData.data.photos}
                        <Card color="light" class="mt-2">
                            <img src={$profilData.data.photos[1].data} class="card-img" alt={$profilData.data.name}>
                        </Card>
                    {/key}
                {/if}
                <Card color="light" class="mt-2">
                    <CardBody>
                        {#if $profilData.data.id == $user.id}
                            <button id="updateAbout" type="button" class="btn btn-outline-secondary position-absolute top-0 end-0" on:click={showHideUpdateAbout}>
                                {#if !updateAbout}
                                    <Icon name="pen-fill" />
                                {:else}
                                    <Icon name="x-circle-fill" />
                                {/if}
                            </button>
                            <Tooltip target="updateAbout" placement="right">{$_("components.ProfilComponents.update")}</Tooltip>
                        {/if}
                        {#if !updateAbout}
                            <ProfilAbout />
                        {:else}
                            <ProfilUpdateAbout />
                        {/if}
                    </CardBody>
                </Card>
                {#if $profilData.data.photos[2]}
                    {#key $profilData.data.photos}
                        <Card color="light" class="mt-2">
                            <img src={$profilData.data.photos[2].data} class="card-img" alt={$profilData.data.name}>
                        </Card>
                    {/key}
                {/if}
                <Card color="light" class="mt-2">
                    <!-- ANCHOR Interest -->
                    <CardBody>
                        {#if $profilData.data.id == $user.id}
                            <button id="updateInterest" type="button" class="btn btn-outline-secondary position-absolute top-0 end-0" on:click={showHideUpdateInterest}>
                                {#if !updateInterest}
                                    <Icon name="pen-fill" />
                                {:else}
                                    <Icon name="x-circle-fill" />
                                {/if}
                            </button>
                            <Tooltip target="updateInterest" placement="right">{$_("components.ProfilComponents.update")}</Tooltip>
                        {/if}
                        <span class="text-muted">Centre d'intérêts :</span>
                        {#if updateInterest}
                            <ProfilUpdateInterest />
                        {:else}
                            <ProfilInterest />
                        {/if}
                    </CardBody>
                </Card>
                {#if $profilData.data.photos[3]}
                    {#key $profilData.data.photos}
                        <Row class="mt-2">
                            <Col>
                                <Image thumbnail src={$profilData.data.photos[3].data} alt={$profilData.data.name} />
                            </Col>                            
                            {#if $profilData.data.photos[4]}
                                <Col>
                                    <Image thumbnail src={$profilData.data.photos[4].data} alt={$profilData.data.name} />
                                </Col>
                            {/if}
                            {#if $profilData.data.photos[5]}
                                <Col>
                                    <Image thumbnail src={$profilData.data.photos[5].data} alt={$profilData.data.name} />
                                </Col>
                            {/if}
                        </Row>
                    {/key}
                {/if}
            </Col>
            <Col lg="4"  md="3" sm="12"  xs="12"></Col>
        </Row>
    </Container>
    {#if $profilData.data.id == $user.id}
        <ProfilPhotoModal {openModalPhoto} {toggleModalPhoto} />
    {/if}
{/if}